import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import SuiBox from '@upheal/design-system/components/legacy/Sui/SuiBox';
import SuiTypography from '@upheal/design-system/components/legacy/Sui/SuiTypography';
import { Mail } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { isWhiteLabelApp } from '@upheal/design-system/theme/legacy/is-whitelabel';
import Stack from '@mui/material/Stack';

type Props = {
    showMail?: boolean;
    color?: string;
    showSocialButtons?: boolean;
};

function Footer(props: Props) {
    const {
        showMail = true,
        color = 'secondary',
        showSocialButtons = true,
    } = props;

    if (isWhiteLabelApp) {
        return null;
    }

    return (
        <Stack component="footer" width="100%" alignItems="center" my={3}>
            {showSocialButtons && (
                <Stack
                    direction="row"
                    justifyContent="center"
                    gap={3}
                    mt={1}
                    mb={3}
                >
                    {showMail && (
                        <Link
                            to={{
                                pathname: 'mailto:hello%40upheal%2eio',
                            }}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <SuiBox
                                sx={{
                                    color,
                                }}
                            >
                                <Mail fontSize="small" />
                            </SuiBox>
                        </Link>
                    )}

                    <Link
                        to={{
                            pathname: 'https://twitter.com/uphealai',
                        }}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <SuiBox
                            sx={{
                                color,
                            }}
                        >
                            <TwitterIcon fontSize="small" />
                        </SuiBox>
                    </Link>

                    <Link
                        to={{
                            pathname: 'https://www.linkedin.com/company/upheal',
                        }}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <SuiBox
                            sx={{
                                color,
                            }}
                        >
                            <LinkedInIcon fontSize="small" />
                        </SuiBox>
                    </Link>
                </Stack>
            )}

            <Stack
                direction={{ xs: 'column-reverse', sm: 'row' }}
                sx={{ textAlign: 'center' }}
                gap={1}
            >
                <SuiTypography
                    variant="body2"
                    sx={{
                        color,
                    }}
                >
                    &copy; {new Date().getFullYear()} Upheal, Inc.
                </SuiTypography>
                <SuiTypography
                    variant="body2"
                    sx={{
                        color,
                        display: { xs: 'none', sm: 'inline' },
                    }}
                >
                    |
                </SuiTypography>
                <Link
                    to={{
                        pathname:
                            'https://www.upheal.io/privacy-and-compliance',
                    }}
                    target="_blank"
                    rel="noreferrer"
                >
                    <SuiTypography
                        variant="body2"
                        sx={{
                            color,
                        }}
                    >
                        <u>Privacy and Compliance</u>
                    </SuiTypography>
                </Link>
            </Stack>
        </Stack>
    );
}

export default Footer;
